// import GenericTemplate from '../../../components/templates/GenericTemplate';
import { BaseTemplate } from '../../../components/templates/BaseTemplate';

const HomeIndex = (): JSX.Element => {
  return <BaseTemplate title="全体的にこうじちゅう">れいじのおもちゃ箱</BaseTemplate>;
};

export default HomeIndex;
